module.exports = __webpack_public_path__ + "static/media/expOrange.4d63804a.svg";